import ReactPlayer from "react-player";
import styled from "styled-components";
import { UserCollection } from "@lifeat/shared/data-models/user/UserEntity";
import { LifeAtTextInputV2 } from "@common/LifeAtTextInput/LifeAtTextInputV2";
import { useDebouncedInput } from "@common/LifeAtTextInput/useDebouncedInput";
import LifeAtVolumeSlider from "@common/LifeAtVolumeSlider/LifeAtVolumeSlider";
import { useDatabaseContext } from "@contexts/DatabaseContext";
import { useGlobalAudioContext } from "@contexts/GlobalAudioContext";
import { useUserContext } from "@contexts/UserContext";

const Container = styled.div<{ disabled: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 8px;

    opacity: ${({ disabled }) => (disabled ? 0.6 : 1.0)};
`;

const StyledPlayer = styled(ReactPlayer)`
    position: absolute;
`;

const StyledVolumeSlider = styled(LifeAtVolumeSlider)`
    width: 75%;
`;

const PLACEHOLDER = "Add youtube url";

type SoundboardYoutubePlayerProps = {
    initialUrl: string;
    initialVolume: number;
    className?: string;
};

export function SoundboardYoutubePlayer(props: SoundboardYoutubePlayerProps) {
    const db = useDatabaseContext();
    const { user } = useUserContext();
    const [url, setUrl] = useDebouncedInput(
        props.initialUrl,
        (value) => db.set(UserCollection.at(user.uid).at("soundboardWidgetSettings").at("youtubeUrl").node, value),
        1000,
    );
    const [volumeSliderInput, setVolumeSliderInput] = useDebouncedInput(
        props.initialVolume,
        (value) => db.set(UserCollection.at(user.uid).at("soundboardWidgetSettings").at("youtubeVolume").node, value),
        1000,
    );
    const { masterVolume } = useGlobalAudioContext();
    const volumeInEffect = volumeSliderInput * masterVolume;

    return (
        <Container className={props.className} disabled={masterVolume === 0}>
            <StyledPlayer
                url={url}
                loop
                height={0}
                pip={false}
                playing={volumeInEffect !== 0}
                volume={volumeInEffect}
            />
            <LifeAtTextInputV2
                showBorder
                placeholder={PLACEHOLDER}
                value={url}
                onChange={(e) => setUrl(e.target.value)}
            />
            <StyledVolumeSlider
                volume={volumeSliderInput}
                setVolume={setVolumeSliderInput}
                disabled={masterVolume === 0}
            />
        </Container>
    );
}
